export default __webpack_public_path__ + "static/f3-025b00c328aa99c3f45c3e15297e5bec.png";